module.exports = __webpack_public_path__ + "resources/img/mark_pims_lg.ef055c6657ddde06ece9e909c2cf4bce.png";